export const msalConfig = {
  auth: {
    clientId: 'c951462f-cbe4-4ce3-922e-a79f5ac594c3',
    authority: 'https://login.microsoftonline.com/463d1a0c-c093-48f0-a89b-11b3ef8e18a7',
    redirectUri: window.location.origin + '/quicklink'
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'api://c951462f-cbe4-4ce3-922e-a79f5ac594c3/user_impersonation']
};
